export default "__VITE_ASSET__ca0768ce__"